const SingleProject = {
  init() {
    this.events();
  },

  events() {
    $('.tabs__item').on('click', (e) => {
      e.preventDefault();
      const btnEl = $(e.currentTarget);

      if (btnEl.hasClass('active')) {
        return;
      }

      const target = btnEl.attr('href');

      $('.tabs__item').removeClass('active');
      btnEl.addClass('active');

      SingleProject.showBlock(target);
    });
  },

  showBlock(href) {
    const block = $(href);

    block.fadeIn().addClass('active').siblings().hide().removeClass('active');
  },
};

export default SingleProject;
